<section class="curation-wrapper">

  <section class="curation-header">
    <section class="curation-header-left-side">
    <dls-tabs>
      <a *ngFor="let tab of tabs" (click)="onTabChange(tab.name)"
         class="{{cssClassFormat(tab.name)}}"
         [ngClass]="{'pt-selected':tab.name === currentTab}">
        <span>{{tab.name}}</span>
      </a>
    </dls-tabs>
    </section>
  </section>

    <section class="curation-section-height">
      <gen-filter-panel-wrapper #filterPanelWrapper
        *ngIf="filterEnabled"
        [type]="curationMainType"
        [subtype]="curationType"
        [enableStatistics]="enableStatistics"
        (updatePanelState)="updatePanelState($event)"
        [ngClass]="{'filters-shown': isFilterPanelOpen}"
        class="filters-hidden"
      >
      </gen-filter-panel-wrapper>

      <section class="curation-table" [ngClass]="{'filter-panel-open': isFilterPanelOpen && filterEnabled, 'filter-panel-closed': !isFilterPanelOpen && filterEnabled}">
        <div [ngClass]="{'filterCountContainer': filterEnabled, 'filterCountContainerDisabled': !filterEnabled}">
          <span *ngIf="filterEnabled" class="fs5_5 filterCount bold-font">
            {{filteredResultsMessage}}
          </span>
          <span class="filterCount" *ngIf="!filterEnabled"></span>
          <section class="curation-header-right-side">
            <gen-export-worklist-data *ngIf="curationType !== 'aberration'" [exportButtonText]="'Export List'"></gen-export-worklist-data>
            <dls-searchbox (search)="searchString = $event;onSearchChange($event);">
              <input dlsInput [ngModel]="text" placeholder="{{placeHolderText | translate}}"
                     (ngModelChange)="text=$event;onSearchChange($event);">
            </dls-searchbox>
            <ng-container *ngIf="!viewOnlyMode" [ngSwitch]="true">
              <ng-container *ngSwitchCase="curationType === 'aberration'">
                <gen-options-button class="aberration-data-wrapper"
                  [buttonIconClass]="'icon__plus'"
                  [buttonText]="createButtonText"
                  [options]="newItemOptions">
                </gen-options-button>
              </ng-container>

              <ng-container *ngSwitchCase="curationType === 'worklist'"></ng-container>

              <ng-container *ngSwitchCase="curationType === 'mda_worklist'"></ng-container>

              <ng-container *ngSwitchDefault>
                <gen-button *ngIf="curationWriteMode" class="options-button Auto_Curation_{{curationType}}-button"
                  [text]="createButtonText"
                  [iconClass]="'icon__plus'"
                  (click)="loadCurationForm()">
                </gen-button>
              </ng-container>

              <ng-container *ngSwitchCase="'clinical_trial'">
                <gen-button *ngIf="curationWriteMode" class="options-button Auto_Curation_options-button"
                  [text]="createButtonText"
                  [iconClass]="'icon__plus'"
                  (click)="loadCurationForm()">
                </gen-button>
              </ng-container>
            </ng-container>
          </section>
        </div>
        <div class="Flexbox flex-wrap-wrap Spacebox__l-regular Spacebox__r-medium Spacebox__t-medium Spacebox__b-small filter-boxes-container"
             style="border-bottom: 1px solid #ccc;">
          <div *ngFor="let appliedFilter of appliedFilterProperties" class="Spacebox__r-small fs8 Spacebox__t-small filter-box">
            <gen-applied-filter id="{{'appliedFilter_' + appliedFilter.name}}" [filter]="appliedFilter">
            </gen-applied-filter>
          </div>
          <div class="Flexbox Flexbox__just-center Flexbox__box-align-center clear-filters-container">
            <span *ngIf="appliedFilterProperties?.length > 0"
                  id="clearAllAppliedFilters"
                  class="fs7 pointer Spacebox__t-small clear-applied-filters"
                  (click)='clearAllAppliedFilters()'>Clear all filters
            </span>
          </div>
        </div>

      <gen-overlay-loader *ngIf="loading" class="curation-dashboard-worklist-loader"></gen-overlay-loader>
      <gen-worklist
          class="table-wrapper Auto_Curation_List"
          [searchPropagation]="false"
          [searchResource]="searchResource"
          [searchText]="searchText"
          [resource]="worklistType"
          [actions]="[]"
          [values]="list|async"
          [trackByField]="'curationItemId'"
          [injectedActions]="injectActions"
          [load]="loading"
          [displayCheckableItems]="curationType !== 'aberration'"
          (rowClicked)="dashboardItemClick($event.data)"
          (noteCompletedEmit)="updateNoteComplete($event)"
          (pageChanged)="pageChanged($event)"
          [executeActions] = "executeActions"
          [checkActionsPermission]="false"
      ></gen-worklist>
    </section>
    </section>
</section>
